import * as React from "react";
import { Button } from "../../../../../../../react-core/Html/Button";

export const CalculateEstimatedPaye = () => {
    return (
        <>
            <div className="row">
                <div className="col-sm-4 col-12 pb-20">
                    <Button className="btn secondary">Calculate estimated PAYE</Button>
                </div>
            </div>
            <div className="recap-dl">
                <dl className="def-list narrow">
                    <dt>Estimated PAYE tax</dt>
                    <dd>
                        <div className="flex-line">
                            <span>£20.00</span>
                            <div className="aria-tooltip-wrapper is-dismissable is-info-icon ml-8 to-the-right">
                                <button className="tooltip-button" title="Tooltip">
                                    <span className="icon" aria-hidden="true"></span>
                                    <span className="text"></span>
                                </button>
                                <div className="tooltip-content" role="tooltip">
                                    <div className="tooltip-content-ar1" aria-hidden="true"></div>
                                    <div className="tooltip-content-panel">
                                        Penguins (order Sphenisciformes, family Spheniscidae) are a group of aquatic
                                        flightless birds. They live almost exclusively in the Southern Hemisphere
                                    </div>
                                    <div className="tooltip-content-ar2" aria-hidden="true"></div>
                                    <button className="tooltip-close-button">
                                        <span className="icon" aria-hidden="true"></span>
                                        <span className="text">Dismiss this tooltip</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </dd>
                    <dt>Estimated net payment</dt>
                    <dd>
                        <span>£80.00</span>
                    </dd>
                    <dt>Basis</dt>
                    <dd>Cumulative</dd>
                </dl>
            </div>
        </>
    );
};
